import { Box,Image, Link } from "@chakra-ui/react";

function Contact(){
  return (
        <Box pb={"150px"} color={"white"} textAlign={"center"}>
            <Box color={"#FFB6C1"} textDecoration={"underline"} pt={"120px"} fontSize={{base:"30px",md:"45px",lg:"60px"}}>
            <h1>Contact</h1>
            </Box>
            <Box fontSize={{base:"17px",md:"20px",lg:"27px"}} mt={"40px"} lineHeight="50px" >
              <p id="contact-phone">Contact Number-8197179210</p>
              <Link target="_blank" href="mailto:imrangadwal777@gmail.com"><p>Email Address-imrangadwal777@gmail.com</p></Link>
              <p>Address-Chittapur,Karnataka</p>
            </Box>
            <Box pt={"80px"} margin={"auto"} justifyContent={"space-around"} w={{base:"300px",md:"400px",lg:"500px"}}  display={"flex"}>
               <Link id="contact-linkedin" target="_blank" href="https://www.linkedin.com/in/imran-gadwal/"><Image w={{base:"35px",md:"50px",lg:"70px"}} src="https://www.productlondondesign.com/wp-content/uploads/2022/02/LinkedIn.png"></Image></Link> 
                <Link  id="contact-github" target="_blank" href="https://github.com/imrangadwal10"><Image w={{base:"30px",md:"40px",lg:"60px"}} src="https://cdn.iconscout.com/icon/free/png-64/github-159-721954.png"></Image></Link> 
                <Link  id="contact-email" target="_blank" href="mailto:imrangadwal777@gmail.com"><Image w={{base:"30px",md:"40px",lg:"60px"}} src="https://cdn.iconscout.com/icon/free/png-64/gmail-30-722694.png"></Image></Link> 
            </Box>
        </Box>
  )
}

export default Contact;